import OperationalReportPage from './OperationalReportPage';
export default function AdvanceOutstandingReportPage(){return <OperationalReportPage kind="advance-outstanding"/>;}
